export default __webpack_public_path__ + "static/media/dog.15fd1804.svg";